import { Directive, ElementRef, EventEmitter, Output } from '@angular/core';
import { HostListener } from '@angular/core';

@Directive({
  selector: '[appDetectInView]',
})
export class DetectInViewDirective {

  @Output() scrolledIntoView = new EventEmitter<void>();
  @Output() scrolledOutOfView = new EventEmitter<void>();

  private element: ElementRef;
  private isElementScrolledIntoView = false;
  private isElementScrolledOutOfView = false;

  @HostListener('window:scroll', ['$event'])
  isScrolledIntoView() {
    this.detectViewStatus();
  }
  
  constructor(private el: ElementRef) {
    this.element = el;
  }

  detectViewStatus(): void {
    if (this.element) {
      const rect = this.element.nativeElement.getBoundingClientRect();
      const topShown = rect.top < window.innerHeight && rect.top >= 0;
      // const bottomShown = rect.bottom <= window.innerHeight;
      const isAlreadyInView = this.isElementScrolledIntoView;
      const isAlreadyOutOfView = this.isElementScrolledOutOfView;
      this.isElementScrolledIntoView = topShown;
      this.isElementScrolledOutOfView = rect.top <= 0 && rect.bottom <= 0;
      if (!isAlreadyInView) {
        if (this.isElementScrolledIntoView) {
          this.scrolledIntoView.emit();
        }
      }
      if (!isAlreadyOutOfView) {
        if (this.isElementScrolledOutOfView) {
          this.scrolledOutOfView.emit();
        }
      }
    }
  }

}
